module.exports = __webpack_public_path__ + "static/img/ss_cy.1ab09e35.png";